import React from 'react';

const Selectable = React.createClass({

  propTypes: {
    selectedClass: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.func
    ]).isRequired,
    id: React.PropTypes.any.isRequired,
    data: React.PropTypes.object,
    clickTargetClassName: React.PropTypes.string
  },

	getInitialState: function() {
		return {
      selected: this.props.selected === true
    }
	},

  componentWillReceiveProps: function(props) {
    if(props !== undefined && props.selected !== this.state.selected) {
      this._updateState(props.selected); 
    }
  },

  render: function() {
    let child = React.Children.only(this.props.children);
    let className = this._getClassName();
    let props = Object.assign({}, child.props, {
      onClick: this.props.overrideClick ? this._getOverrideClickHandler(child) : this._wrapClickHandler(child),
      selected: this.state.selected,
      className: [this.props.className, child.props.className, className].join(' ')
    });
    
    return (
      <child.type {...props} />
    )
  },

  toggleSelect: function() {
    let selected = !this.state.selected;
    this._updateState(selected);
    return selected;
  },

  select: function() {
    this._updateState(true);
  },

  unselect: function() {
    this._updateState(false);
  },

  handleClick: function(e) {
    if(!this.props.clickTargetClassName || 
        e.target.className.indexOf(this.props.clickTargetClassName) !== -1) {
      this.toggleSelect();
    }
  },

  _updateState: function(selected) {
    if(selected === this.state.selected) {
      return;
    }
    
    this.setState({
      selected: selected
    });
    
    if(this.props.onChange) {
      this.props.onChange(this.props.id, this, this.props.data, selected);
    }
  },

  _getClassName: function(selected) {
    let className = null;
    let selectedClass = this.props.selectedClass;
    if(typeof this.props.selectedClass !== 'function') {
      selectedClass = () => this.props.selectedClass;
    }
  	
    if(this.state.selected) {
      className = selectedClass(this.props.data);
    }

    return className;
  },

  _wrapClickHandler: function(child) {
    return (e) => {
      this.handleClick(e);
      if(child.props.onClick) {
        child.props.onClick(e);
      }
    }
  },

  _getOverrideClickHandler: function(child) {
    let handleClick = null;
    if(child.props.onClick) {
      handleClick = child.props.onClick.bind(null, this);
    }

    return handleClick;
  }

});

export default Selectable;



/** WEBPACK FOOTER **
 ** ./src/js/components/common/selectable.js
 **/